import React, { useState, useEffect, useContext } from "react";
import {
    Col,
    Form,
    OverlayTrigger, Tooltip,
    Row
} from "react-bootstrap";
import NotyfContext from "../../contexts/NotyfContext.js";
import PopoverPicker from "../../components/PopoverPicker.js";

import { BackgroundFormComponent } from '../../components/Applications';
import { redirectURL } from "../../assets/functions.js";

const Roullete = ({
    handleChange,
    values,
    setFieldValue,
    errors,
    touched,
    handlePreviewSuccess,
    handlePreviewError
}) => {
    const notyf = useContext(NotyfContext);
    const [props, setProps] = useState({
        backgroundColor: values.json.apresentation?.textSide?.background?.color,
        textColor: values.json.apresentation?.textSide?.textColor
    });

    useEffect(() => {
        notyf.open({
            type: "warning",
            message: "Esse aplicativo possui definições adicionais no modo apresentador",
            ripple: true,
            dismissible: true,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">Definições</h5>
            </Form.Group>

            <Row className="mx-0 mb-3">
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        type="text"
                        name="titulo"
                        value={values.titulo}
                        onChange={handleChange}
                        isInvalid={!!errors.titulo}
                        isValid={touched.titulo && !errors.titulo}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.titulo}
                    </Form.Control.Feedback>
                </Form.Group>
                <p className="text-start fw-bold mb-2">Tela da roleta</p>
                <div className="d-flex text-start">
                    <Form.Group sm={3} className='mb-3'>
                        <Form.Check
                            className="w-auto mb-0"
                            checked={values.json.rouletteType === 'iframe' ? true : false}
                            type="checkbox"
                            name="json.rouletteType"
                            label="Unity Iframe"
                            onChange={(e) => {
                                setFieldValue(
                                    "json.rouletteType",
                                    'iframe'
                                );
                            }}
                        />
                    </Form.Group>
                    <Form.Group sm={3} className='mb-3 ms-3'>
                        <Form.Check
                            className="w-auto mb-0"
                            checked={values.json.rouletteType === 'wheel' ? true : false}
                            type="checkbox"
                            name="json.rouletteType"
                            label="Roleta tradicional"
                            onChange={(e) => {
                                setFieldValue(
                                    "json.rouletteType",
                                    'wheel'
                                );
                            }}
                        />
                    </Form.Group>
                </div>
                {values.json.rouletteType === 'iframe' && <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12">
                    <Form.Label>Unity URL</Form.Label>
                    <Form.Control
                        type="text"
                        name="json.unityUrl"
                        value={values.json.unityUrl}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.unityUrl}
                        isValid={touched?.json?.unityUrl && !errors?.json?.unityUrl}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.unityUrl}
                    </Form.Control.Feedback>
                </Form.Group>}
                {values.json.rouletteType === 'wheel' && <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12">
                    <Form.Check
                        className="w-auto mb-0"
                        checked={values.json.apresentation.configs.sound ? true : false}
                        type="checkbox"
                        name="json.apresentation.configs.sound"
                        label="Ativar sons interativos"
                        onChange={(e) => {
                            setFieldValue(
                                "json.apresentation.configs.sound",
                                values.json.apresentation.configs.sound ? false : true
                            );
                        }}
                    />
                </Form.Group>}
            </Row>

            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">
                    Participante
                </h5>
            </Form.Group>
            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mb-2">Tela inicial</p>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"
                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        as={'textarea'}
                        name="json.initialScreen.title"
                        value={values.json.initialScreen?.title}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.initialScreen?.title}
                        isValid={touched?.json?.initialScreen?.title && !errors.json?.initialScreen?.title}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.initialScreen?.title}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"
                >
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                        as={'textarea'}
                        name="json.initialScreen.description"
                        value={values.json.initialScreen?.description}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.initialScreen?.description}
                        isValid={touched?.json?.initialScreen?.description && !errors.json?.initialScreen?.description}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.initialScreen?.description}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="8"
                >
                    <Form.Label>Botão</Form.Label>
                    <Form.Control
                        type="text"
                        name="json.initialScreen.buttonText"
                        value={values.json.initialScreen?.buttonText}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.initialScreen?.buttonText}
                        isValid={touched?.json?.initialScreen?.buttonText && !errors.json?.initialScreen?.buttonText}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.initialScreen?.buttonText}
                    </Form.Control.Feedback>
                </Form.Group>
                <p className="text-start fw-bold mb-2 mt-3">Tela de resultado</p>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        as={'textarea'}
                        name="json.endPage.title"
                        value={values.json.endPage?.title}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.endPage?.title}
                        isValid={touched?.json?.endPage?.title && !errors.json?.endPage?.title}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.endPage?.title}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="8"

                >
                    <Form.Label>Botão</Form.Label>
                    <Form.Control
                        type="text"
                        name="json.endPage.buttonText"
                        value={values.json.endPage?.buttonText}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.endPage?.buttonText}
                        isValid={touched?.json?.endPage?.buttonText && !errors.json?.endPage?.buttonText}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.endPage?.buttonText}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">
                    Modo de apresentação
                </h5>
            </Form.Group>
            <Row className="mx-0">
                <Form.Group as={Col} sm={12} className="mb-3 px-0">
                    <p className="text-start fw-bold mb-2">Formulário</p>
                    <div className="d-flex text-start">
                    <Form.Group sm={4} className="mb-3">
                        <Form.Check
                        className="mode"
                        checked={
                            values.json.apresentation.configs.form === false ? true : false
                        }
                        type="checkbox"
                        name={"json.apresentation.configs.form"}
                        onChange={(e) => {
                            setFieldValue("json.apresentation.configs.form", false);
                        }}
                        label={`Sem coleta`}
                        isInvalid={!!errors.json?.apresentation?.configs?.form}
                        feedback={errors.json?.apresentation?.configs?.form}
                        feedbackType="invalid"
                        ></Form.Check>
                    </Form.Group>
                    <Form.Group sm={4} className="mb-3 ms-3">
                        <Form.Check
                        className="mode"
                        checked={
                            values.json.apresentation.configs.form === 1 || values.json.apresentation.configs.form === undefined ? true : false
                        }
                        type="checkbox"
                        name={"json.apresentation.configs.form"}
                        onChange={(e) => {
                            setFieldValue("json.apresentation.configs.form", 1);
                        }}
                        label={`Antes da roleta`}
                        isInvalid={!!errors.json?.apresentation?.configs?.form}
                        feedback={errors.json?.apresentation?.configs?.form}
                        feedbackType="invalid"
                        ></Form.Check>
                    </Form.Group>
                    <Form.Group sm={4} className="mb-3 ms-3">
                        <Form.Check
                        className="mode"
                        checked={
                            values.json.apresentation.configs.form === 2 ? true : false
                        }
                        type="checkbox"
                        name={"json.apresentation.configs.form"}
                        onChange={(e) => {
                            setFieldValue("json.apresentation.configs.form", 2);
                        }}
                        label={`Depois da roleta`}
                        isInvalid={!!errors.json?.apresentation?.configs?.form}
                        feedback={errors.json?.apresentation?.configs?.form}
                        feedbackType="invalid"
                        ></Form.Check>
                    </Form.Group>
                    </div>
                </Form.Group>
            </Row>
            <Row className="mx-0">
                <Form.Group
                    as={Col}
                    md={4}
                    className="mb-3"
                >
                    <Form.Label>Tamanho fonte (M) (rem)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.h5"
                        step={"0.01"}
                        value={values.json.apresentation?.textSide?.h5}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.h5}
                        isValid={touched.json?.apresentation?.textSide?.h5 && !errors.json?.apresentation?.textSide?.h5}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.h5}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                    as={Col}
                    md={4}
                    className="mb-3"
                >
                    <Form.Label>Tamanho fonte (P) (rem)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.p"
                        step={"0.01"}
                        value={values.json.apresentation.textSide.p}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.p}
                        isValid={touched.json?.apresentation?.textSide?.p && !errors.json?.apresentation?.textSide?.p}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.p}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    as={Col}
                    md="4">
                    <Form.Label>Tipo de plano de fundo {values.json.apresentation.textSide.background.type === 'color' && <OverlayTrigger
                        overlay={<Tooltip><b>Exemplo: </b>linear-gradient(90deg,rgba(42, 123, 155, 1) 0%, rgba(87, 199, 133, 1) 50%, rgba(237, 221, 83, 1) 100%)</Tooltip>}
                    >
                        <span className="badge text-dark bg-light cursor-pointer ms-1" onClick={() => redirectURL(true, 'https://cssgradient.io/')}>CSS Gradient</span>
                    </OverlayTrigger>}</Form.Label>
                    <Form.Select
                        name="json.apresentation.textSide.background.type"
                        onChange={handleChange}
                        value={values.json.apresentation.textSide.background.type}
                        isInvalid={!!errors.json?.apresentation?.textSide?.background?.type}
                        isValid={touched.json?.apresentation?.textSide?.background?.type && !errors.json?.apresentation?.textSide?.background?.type}>
                        <option value={"color"}>
                            Cor
                        </option>
                        <option value={"image"}>
                            Imagem
                        </option>
                        <option value={"video"}>
                            Vídeo
                        </option>
                    </Form.Select>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">{errors.json?.apresentation?.textSide?.background?.type}</Form.Control.Feedback>
                </Form.Group>
            </Row>

            {values.json?.apresentation?.textSide?.background?.type !== 'color' ? <Row className="mb-3 mx-0">
                <BackgroundFormComponent touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} handlePreviewSuccess={handlePreviewSuccess} handlePreviewError={handlePreviewError}></BackgroundFormComponent>
            </Row> :
                <Row className="mx-0 mb-3">
                    <div className="col-md-3 mb-3">
                        <Form.Label>Cor de fundo</Form.Label>
                        <div className={`d-flex justify-content-start align-items-center ${errors?.json?.apresentation?.textSide?.background?.color ? 'is-invalid' : ''}`}>
                            <Form.Control
                                type="hidden"
                                name="json.apresentation.textSide.background.color"
                                value={values.json.apresentation.textSide.background.color}
                                isInvalid={!!errors?.json?.apresentation?.textSide?.background?.color}
                                isValid={touched?.json?.apresentation?.textSide?.background?.color && !errors?.json?.apresentation?.textSide?.background?.color}
                            />
                            <PopoverPicker
                                color={props.backgroundColor}
                                onChangeX={(e) => {
                                    setFieldValue("json.apresentation.textSide.background.color", e);
                                    setProps(prevState => ({
                                        ...prevState,
                                        backgroundColor: e
                                    }));
                                }}
                                classes={`me-1 picker ${errors?.json?.apresentation?.textSide?.background?.color ? 'is-invalid' : ''}`}
                            />
                        </div>
                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">
                            {errors?.json?.apresentation?.textSide?.background?.color ? errors?.json?.apresentation?.textSide?.background?.color : ''}
                        </Form.Control.Feedback>
                    </div>
                </Row>
            }

            <Row className="mx-0 mb-3">
                <div className="col-md-4 mb-3">
                    <Form.Label>Cor de texto</Form.Label>
                    <div className={`d-flex justify-content-start align-items-center ${errors?.json?.apresentation?.textSide?.textColor ? 'is-invalid' : ''}`}>
                        <Form.Control
                            type="hidden"
                            name="json.apresentation.textSide.textColor"
                            value={values.json?.apresentation?.textSide?.textColor}
                            isInvalid={!!errors?.json?.apresentation?.textSide?.textColor}
                            isValid={touched?.json?.apresentation?.textSide?.textColor && !errors?.json?.apresentation?.textSide?.textColor}
                        />
                        <PopoverPicker
                            color={props.textColor}
                            onChangeX={(e) => {
                                setFieldValue("json.apresentation.textSide.textColor", e);
                                setProps(prevState => ({
                                    ...prevState,
                                    textColor: e
                                }));
                            }}
                            classes={`me-1 picker ${errors?.json?.apresentation?.textSide?.textColor ? 'is-invalid' : ''}`}
                        />
                    </div>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.apresentation?.textSide?.textColor ? errors?.json?.apresentation?.textSide?.textColor : ''}
                    </Form.Control.Feedback>
                </div>
            </Row>
            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mt-3 mb-2">Logomarca</p>
                <Form.Group as={Col} sm={6} className='mb-3'>
                    <Form.Label>Largura da logomarca (px)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.configs.logoSize"
                        value={values.json.apresentation.configs.logoSize}
                        onChange={(e) => {
                            handleChange(e);
                        }}
                        isInvalid={!!errors.json?.apresentation?.configs?.logoSize}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.configs?.logoSize}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mb-2">Tela do formulário</p>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        as={'textarea'}
                        name="json.apresentation.register.title"
                        value={values.json?.apresentation?.register?.title}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.apresentation?.register?.title}
                        isValid={touched?.json?.apresentation?.register?.title && !errors.json?.apresentation?.register?.title}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.apresentation?.register?.title}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mb-2">Tela do resultado</p>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        as={'textarea'}
                        name="json.apresentation.endPage.title"
                        value={values.json.apresentation?.endPage?.title}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.apresentation?.endPage?.title}
                        isValid={touched?.json?.apresentation?.endPage?.title && !errors.json?.apresentation?.endPage?.title}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.apresentation?.endPage?.title}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="8"

                >
                    <Form.Label>Botão</Form.Label>
                    <Form.Control
                        type="text"
                        name="json.apresentation.endPage.buttonText"
                        value={values.json.apresentation?.endPage?.buttonText}
                        onChange={handleChange}
                        isInvalid={!!errors?.json?.apresentation?.endPage?.buttonText}
                        isValid={touched?.json?.apresentation?.endPage?.buttonText && !errors.json?.apresentation?.endPage?.buttonText}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.apresentation?.endPage?.buttonText}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} sm={6} className='mb-3'>
                    <Form.Label>Finalizar fluxo automaticamente (milissegundos)</Form.Label>
                    <Form.Control
                        type="number"
                        step={1000}
                        name="json.apresentation.configs.qrcodeEndPage"
                        value={values.json.apresentation.configs.qrcodeEndPage}
                        onChange={(e) => {
                            handleChange(e);
                        }}
                        isInvalid={!!errors.json?.apresentation?.configs?.qrcodeEndPage}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.configs?.qrcodeEndPage}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};

export default Roullete